import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import MuiButton from '../muiButton'

export const Button = styled(MuiButton)(`
  margin-left: 0 !important;
  text-transform: capitalize;
`)

export const DialogActions = styled(Box)(`
  display: flex;
  justify-content: space-between;
`)

export const Title = styled(Typography)(`
  font-size: 16px;
  line-height: 20px;
  padding-bottom: 10px;
  font-style: normal;
  font-weight: 400;
  white-space: pre-wrap;
`)

export const Description = styled(Typography)(`
  font-size: 12px;
  line-height: 16px;
  padding-bottom: 10px;
  font-weight: 400; // 300;
  white-space: pre-wrap;
`)

export const Wrapper = styled(Box)(`
  width: 300px;
`)
